







import { useDispatch, useSelector } from 'react-redux';
import styled, { css } from 'styled-components';

import {
  handleInstantHeatOff,
  selectEssSwitch,
  handleSnowSensorOff,
  handleSnowSensor,
  handleWindFactor,
  handleWindFactorOff,
  handleAddHeatingSchedule,
  handleReadyHeatingSchedule,
  handleClearHeatingSchedule,
  essHandleUnselectAllProgram,
  essHandleSelectProgram,
  handleMachineOptionalConstantTempOff,
  handleOptionalConstantTempReady,
  handleInstantHeatReady,
} from 'shared/slice/essSwitchSlice';
import {
  flexBoxCenter,
  layerA,
  layerA180Deg,
  layerC,
  justifyContentSpaceBetween,
  readyTop180Deg,
  activeLayer180Deg,
  activeInput,
  layerADark,
  flexDirectionColumn,
} from 'shared/styles/commonStyles';

import MCConstantTemp from 'shared/components/commonComponentsMC/controllers/MCConstantTemp';
import MCDisplayBoxWrapper from 'shared/components/commonComponentsMC/controllers/MCDisplayBoxWrapper';
import MCHeatingSchedule from 'shared/components/commonComponentsMC/controllers/MCHeatingSchedule';
import MCInstantHeat from 'shared/components/commonComponentsMC/controllers/MCInstantHeat';
import MCSnowSensor from 'shared/components/commonComponentsMC/controllers/MCSnowSensor';
import MCWindFactor from 'shared/components/commonComponentsMC/controllers/MCWindFactor';
import { useEffect, useState, useMemo } from 'react';
import InputTempMessage from 'shared/components/userMessages/inputTempMessage';
import MachineTelemetry from 'shared/components/commonComponentsMC/MachineTelemetry';
import HeaterStatus from 'shared/components/commonComponentsMC/HeaterStatus';
import { selectUnits } from 'shared/slice/unitsSlice';
import { selectUserPermissions } from 'shared/slice/userSlice';
import {
  convertCelsiusToFahrenheit,
  convertFahrenheitToCelsius,
  formatTime,
} from 'shared/helpers/helpers';
import { postEssCommand } from 'features/masterControl/services/sendCommand.service';
import {
  createScheduleService,
  deleteScheduleService,
  updateScheduleService,
} from 'shared/services/schedule.service';

const EssControlBox = ({
  isMobile,
  location,
  machine,
  swtName,
  setTemp,
  indivLocationName,
}) => {

  const { flatEssSwitch: flatSwitchStatus } = useSelector(selectEssSwitch);

  const switchStatus =  flatSwitchStatus[location][machine];
  const {
    deviceMac,
    isFaults,
    isOff,
    instantHeat,
    snowSensor,
    optionalConstantTemp,
    heatingScheduleList,
    heatingSchedule,
    windFactor,
    mobileSelectedProgram,
    isDisabled,
    deviceStatus,
  } = switchStatus;

  const unitsStatus = useSelector(selectUnits);
  const { isF } = unitsStatus;


  const [instantHeatTemp, setInstantHeatTemp] = useState('');
  const [constantTemp, setConstantTemp] = useState('');
  const [schedulerTemp, setSchedulerTemp] = useState('');
  const [snowSensorTemp, setSnowSensorTemp] = useState('');

  const [openMessageBox, setOpenMessageBox] = useState(false);
  const [message, setMessage] = useState([]);
  const [programName, setProgramName] = useState(null);
  const dispatch = useDispatch();

  const permissions = useSelector(selectUserPermissions);
  const disable = !permissions.WRITE;


  const unit = isF ? '°F' : '°C';


  const heatingScheduleActivated = useMemo(() => {
    return switchStatus.heatingSchedule.isActivated && switchStatus.op_mode === "SCHEDULE" ;
  }, [switchStatus]);

  const snowSensorActivated = useMemo(() => {
    return switchStatus.snowSensor.isActivated && switchStatus.op_mode === "SNOW" ;
  }, [switchStatus]);

  const instantHeatActivated = useMemo(() => {
    return switchStatus.instantHeat.isActivated && switchStatus.op_mode === "SWITCH" ;
  }, [switchStatus]);

  const windFactorActivated = useMemo(() => {
    return switchStatus.windFactor.isActivated && switchStatus.op_mode === "WIND" ;
  }, [switchStatus]);



  useEffect(() => {
    if (instantHeat.inputTemp > 0) {
      setInstantHeatTemp(`${instantHeat.inputTemp} ${unit}`);
    } else {
      setInstantHeatTemp('');
    }
  }, [instantHeat]);

  useEffect(() => {
    if (heatingScheduleList[0].inputTemp > 0) {
      setSchedulerTemp(`${heatingScheduleList[0].inputTemp} ${unit}`);
      dispatch(
        handleReadyHeatingSchedule({
          location,
          machine,
          state: true,
        })
      );
    } else {
      setSchedulerTemp('');
      dispatch(
        handleReadyHeatingSchedule({
          location,
          machine,
          state: false,
        })
      );
    }
  }, [heatingScheduleList,switchStatus]);

  useEffect(() => {
    if (optionalConstantTemp.inputTemp > 0) {
      setConstantTemp(`${optionalConstantTemp.inputTemp} ${unit}`);
    } else {
      setConstantTemp('');
    }
  }, [optionalConstantTemp]);

  useEffect(() => {
    if (snowSensor.defaultTemp > 0) {
      setSnowSensorTemp(
        `${
          isF
            ? convertCelsiusToFahrenheit(snowSensor.defaultTemp)
            : snowSensor.defaultTemp
        } ${unit}`
      );
    } else {
      setSnowSensorTemp('');
    }
  }, [snowSensor]);

  const integratedButtonHandler = (id, state, temp, data, index) => {
    switch (id) {
      case 'instantHeat':
        instantHeatHandler(state, temp);
        break;
      case 'snowSensor':
        snowSensorHandler(state);
        break;
      case 'constantTemp':
        constantTempHandler(state, temp);
        break;
      case 'windFactor':
        windFactorHandler(state);
        break;
      case 'heatingSchedule':
        heatingScheduleHandler(state, temp, data, index);
        break;
        default: break;
    }
  };


  const heatingScheduleHandler = (state, temp, data, index) => {

    if (state === 'off') {
      const data = [
        {
          start: { date: null, time: null },
          end: { date: null, time: null },
          inputTemp: null,
          isF: null,
        },
      ];
      dispatch(
        handleClearHeatingSchedule({
          location,
          machine,
          data,
        })
      );
    } else if (state === 'clear') {

      let data;
      if (heatingSchedule.length === 2) {
        data = [
          {
            start: { date: null, time: null },
            end: { date: null, time: null },
            inputTemp: null,
            isF: null,
            id: null,
          },
        ];
        deleteScheduleService(heatingScheduleList[index]?.id)
          .then(() => {
            dispatch(
              handleClearHeatingSchedule({
                location,
                machine,
                data,
              })
            );
          })
          .catch((err) => {
            console.log('delete heating schedule fail:', err);
          });
      } else if (heatingScheduleList.length - 1 === index) {
      } else {
        data = heatingScheduleList.filter(
          (schedule, idx) => index !== idx && schedule
        );
        deleteScheduleService(heatingScheduleList[index]?.id)
          .then(() => {
            dispatch(
              handleClearHeatingSchedule({
                location,
                machine,
                data,
              })
            );
          })
          .catch((err) => {
            console.log('delete heating schedule fail:', err);
          });
      }
    } else {


      const startDate = formatTime({ ...data.start });
      const endDate = formatTime({ ...data.end });
      const threshold = isF ? convertFahrenheitToCelsius(temp) : temp;
      const scheduleData = {
        deviceId: deviceMac,
        deviceType: 'ESS',
        startDate,
        endDate,
        threshold,
      };
      if (heatingScheduleList[index]?.id) {
        updateScheduleService(heatingScheduleList[index]?.id, scheduleData)
          .then((res) => {
            dispatch(
              handleAddHeatingSchedule({
                location,
                machine,
                start: data.start,
                end: data.end,
                index,
                inputTemp: temp,
                isF,
                id: res.id,
              })
            );
          })
          .catch((e) => {
            console.log('update heating schedule fail:', e.message);
          });
      } else {
        createScheduleService(scheduleData)
          .then((res) => {
            dispatch(
              handleAddHeatingSchedule({
                location,
                machine,
                start: data.start,
                end: data.end,
                index,
                inputTemp: temp,
                isF,
                id: res.id,
              })
            );
          })
          .catch((e) => {
            console.log('create heating schedule fail:', e.message);
          });
      }
    }
  };

  const instantHeatHandler = (state, temp) => {
    if (state === 'on') {

      postEssCommand(deviceMac, 'on_switch', 1);
      postEssCommand(
        deviceMac,
        'instant_temp',
        isF ? convertFahrenheitToCelsius(temp) : temp
      );
      dispatch(
        handleInstantHeatReady({
          location,
          machine,
          isF,
          temp,
        })
      );
    } else if (state === 'off') {

      postEssCommand(deviceMac, 'on_switch', 0);
      dispatch(handleInstantHeatOff({ location, machine }));
    } else {


      setProgramName('instant heat');
      handleMessageBox(state, 'instant heat');
    }
  };

  const constantTempHandler = (state, temp) => {
    if (state === 'on') {

      postEssCommand(
        deviceMac,
        'constant_temp',
        isF ? convertFahrenheitToCelsius(temp) : temp
      );
      postEssCommand(deviceMac, 'on_constant', 1);
      dispatch(
        handleOptionalConstantTempReady({
          location,
          machine,
          isF,
          temp,
        })
      );
    } else if (state === 'off') {

      postEssCommand(deviceMac, 'on_constant', 0);
      dispatch(
        handleMachineOptionalConstantTempOff({
          location,
          machine,
        })
      );
    } else {


      setProgramName('optional constant temp.');
      handleMessageBox(state, 'optional constant temp');
    }
  };

  const snowSensorHandler = (state) => {
    if (state === 'off') {
      postEssCommand(deviceMac, 'snow_enabled', 0);
      dispatch(handleSnowSensorOff({ location, machine }));
    } else if (state === 'on') {

      postEssCommand(deviceMac, 'snow_enabled', 1);
      dispatch(handleSnowSensor({ location, machine }));
    } else {
      setProgramName('snow sensor program');
      handleMessageBox(state, 'snow sensor program');
    }
  };

  const windFactorHandler = (state) => {
    if (state === 'off') {
      postEssCommand(deviceMac, 'wind', 0);
      dispatch(handleWindFactorOff({ location, machine }));
    } else {

      postEssCommand(deviceMac, 'wind', 1);
      dispatch(handleWindFactor({ location, machine }));
    }
  };

  const handleMessageBox = (id, program) => {
    switch (id) {
      case 'tempA':

        setMessage([
          `in order to finalize ${program} `,
          'please input your temperature',
          '( the minimum temperature is 121°C - 250°F )',
          '( the maximum temperature is 999°C - 1830°F )',
        ]);

        setOpenMessageBox(true);
        break;
      case 'tempB':
        setMessage([
          `in order to finalize ${program} `,
          'please input your temperature',
          '( the minimum temperature is 25°C - 77°F )',
          '( the maximum temperature is 120°C - 248°F )',
        ]);
        setOpenMessageBox(true);
        break;
      case 'selectA':
        setMessage(['please select locations first']);
        setOpenMessageBox(true);
        break;
      case 'selectB':
        setMessage(['please select locations and a schedule first']);
        setOpenMessageBox(true);
        break;
      default:
        throw new Error('unknown error', id);
    }
  };


  const handleSwitchController = (program) => {
    if (program === 'unselect') {
      dispatch(
        essHandleUnselectAllProgram({ location, machine })
      );
    } else {
      if (mobileSelectedProgram[program]) {
        dispatch(
          essHandleUnselectAllProgram({ location, machine })
        );
      } else {
        dispatch(
          essHandleUnselectAllProgram({ location, machine })
        );
        dispatch(
          essHandleSelectProgram({
            location,
            machine,
            program,
          })
        );
      }
    }
  };

  return (
    <>
      {isMobile ? (
        <Wrapper isMobile={true}>
          <SectionMobileSwitches
            isExpanded={Object.values(mobileSelectedProgram).includes(true)}
          >
            <MobileSwitchesInner>
              <SectionLogo>
                <Button
                  noButton={
                    !Object.values(mobileSelectedProgram).some(
                      (select) => select === true
                    )
                  }
                  onClick={() => handleSwitchController('unselect')}
                >
                  <ButtonHole>
                    <ButtonTop>
                      <IconImg src='/images/mc-title.svg' isMc={true} />
                    </ButtonTop>
                  </ButtonHole>
                </Button>
              </SectionLogo>

              <SectionController>
                <SectionLogo>
                  <Button
                    isActivated={instantHeat.isActivated}
                    isReady={instantHeat.isReady}
                    isSelected={mobileSelectedProgram.instantHeat}
                    onClick={() => {
                      handleSwitchController('instantHeat');
                    }}
                  >
                    <ButtonHole isActivated={instantHeat.isActivated}>
                      <IconImg src='/images/logo-instantHeat.svg' />
                    </ButtonHole>
                  </Button>
                </SectionLogo>

                <SectionLogo>
                  <Button
                    isActivated={snowSensor.isActivated}
                    isReady={snowSensor.isReady}
                    isSelected={mobileSelectedProgram.snowSensor}
                    onClick={() => {
                      handleSwitchController('snowSensor');
                    }}
                  >
                    <ButtonHole isActivated={snowSensor.isActivated}>
                      <IconImg src='/images/logo-snowSensor.svg' />
                    </ButtonHole>
                  </Button>
                </SectionLogo>

                <SectionLogo>
                  <Button
                    isActivated={optionalConstantTemp.isActivated}
                    isReady={optionalConstantTemp.isReady}
                    isSelected={mobileSelectedProgram.optionalConstantTemp}
                    onClick={() =>
                      handleSwitchController('optionalConstantTemp')
                    }
                  >
                    <ButtonHole isActivated={optionalConstantTemp.isActivated}>
                      <IconImg src='/images/logo-constantTemp.svg' />
                    </ButtonHole>
                  </Button>
                </SectionLogo>

                <SectionLogo>
                  <Button
                    isActivated={heatingSchedule.isActivated}
                    isReady={heatingSchedule.isReady}
                    isSelected={mobileSelectedProgram.heatingSchedule}
                    onClick={() => handleSwitchController('heatingSchedule')}
                  >
                    <ButtonHole isActivated={heatingSchedule.isActivated}>
                      <IconImg src='/images/logo-schedule.svg' />
                    </ButtonHole>
                  </Button>
                </SectionLogo>

                <SectionLogo>
                  <Button
                    isActivated={windFactor.isActivated}
                    isReady={windFactor.isReady}
                    isSelected={mobileSelectedProgram.windFactor}
                    onClick={() => handleSwitchController('windFactor')}
                  >
                    <ButtonHole isActivated={windFactor.isActivated}>
                      <IconImg src='/images/logo-windFactor.svg' />
                    </ButtonHole>
                  </Button>
                </SectionLogo>
              </SectionController>
            </MobileSwitchesInner>
          </SectionMobileSwitches>

          {mobileSelectedProgram.instantHeat && (
            <MCInstantHeat
              isMobile={isMobile}
              handleOnClick={integratedButtonHandler}
              isActivated={instantHeat.isActivated}
              setTempInput={setInstantHeatTemp}
              tempInput={instantHeatTemp}
              setMessage={setMessage}
              isDisabled={isDisabled || disable}
              isReady={instantHeat.isReady}
            />
          )}

          {mobileSelectedProgram.snowSensor && (
            <MCSnowSensor
              isMobile={true}
              handleOnClick={integratedButtonHandler}
              isActivated={snowSensorActivated}
              isReady={snowSensor.isReady}
              defaultTemp={snowSensorTemp}
              isDisabled={isDisabled || disable}
            />
          )}

          {mobileSelectedProgram.optionalConstantTemp && (
            <MCConstantTemp
              isMobile={true}
              handleOnClick={integratedButtonHandler}
              isActivated={optionalConstantTemp.isActivated}
              isReady={optionalConstantTemp.isReady}
              setTempInput={setConstantTemp}
              tempInput={constantTemp}
              isDisabled={isDisabled || disable}
            />
          )}

          {mobileSelectedProgram.windFactor && (
            <MCWindFactor
              isMobile={true}
              handleOnClick={integratedButtonHandler}
              isActivated={windFactorActivated}
              isReady={windFactor.isReady}
              isDisabled={isDisabled || disable}
            />
          )}
          {mobileSelectedProgram.heatingSchedule && (
            <MCHeatingSchedule
              isMobile={true}
              handleOnClick={integratedButtonHandler}
              heatingScheduleList={heatingScheduleList}
              isActivated={heatingScheduleActivated}
              isReady={heatingSchedule.isReady}
              tempInput={schedulerTemp}
              setTempInput={setSchedulerTemp}
              isDisabled={isDisabled || disable}
            />
          )}








          <MachineTelemetry
            swtName='ess'
            location={location}
            machine={machine}
            setTemp={setTemp}
          />

          <HeaterStatus
            isMobile={true}
            swtName='ess'
            location={location}
            machine={machine}
            isFaults={isFaults}
            isOff={isOff}
            indivLocationName={indivLocationName}
          />
        </Wrapper>
      ) : (
        <Wrapper>
          <SectionHeader>
            <HeaderHatSvg
              src={
                isFaults
                  ? '/images/controller-hat-faults.svg'
                  : '/images/controller-hat.svg'
              }
            />
            <HeaderTitleWrapper>
              <Title right={true}>
                {swtName}
                -controls
              </Title>

              <Title right={false}>id : { deviceStatus === 'NOT_LINKED' ? '' : deviceMac}</Title>
            </HeaderTitleWrapper>
          </SectionHeader>

          <SectionMain isFaults={isFaults}>
            <MainInnerWrapper>
              <MCInstantHeat
                handleOnClick={integratedButtonHandler}
                isActivated={instantHeatActivated}
                setTempInput={setInstantHeatTemp}
                tempInput={instantHeatTemp}
                setMessage={setMessage}
                isDisabled={isDisabled || disable}
                isReady={instantHeat.isReady}
                swtName={swtName}
                location={location}
                machine={machine}
              />
              <MCSnowSensor
                handleOnClick={integratedButtonHandler}
                isActivated={snowSensorActivated}
                isReady={snowSensor.isReady}
                defaultTemp={snowSensorTemp}
                isDisabled={isDisabled || disable}
                swtName={swtName}
                location={location}
                machine={machine}
              />
              <MCConstantTemp
                handleOnClick={integratedButtonHandler}
                isActivated={optionalConstantTemp.isActivated}
                isReady={optionalConstantTemp.isReady}
                setTempInput={setConstantTemp}
                tempInput={constantTemp}
                isDisabled={isDisabled || disable}
                swtName={swtName}
                location={location}
                machine={machine}
              />

              <MCHeatingSchedule
                handleOnClick={integratedButtonHandler}
                heatingScheduleList={heatingScheduleList}
                isActivated={heatingScheduleActivated}
                isReady={heatingSchedule.isReady}
                tempInput={schedulerTemp}
                setTempInput={setSchedulerTemp}
                isDisabled={isDisabled || disable}
                swtName={swtName}
                location={location}
                machine={machine}
              />

              <MCWindFactor
                handleOnClick={integratedButtonHandler}
                isActivated={windFactorActivated}
                isReady={windFactor.isReady}
                isDisabled={isDisabled || disable}
                swtName={swtName}
                location={location}
                machine={machine}
              />
              <MCDisplayBoxWrapper
                swtName={swtName}
                location={location}
                machine={machine}
              />
            </MainInnerWrapper>
          </SectionMain>

          {openMessageBox && (
            <MessageBoxWrapper>
              <InputTempMessage
                onClose={() => setOpenMessageBox(false)}
                messages={message}
                title={programName}
              />
            </MessageBoxWrapper>
          )}






        </Wrapper>
      )}
    </>
  );
};

export default EssControlBox;

const SectionMobileSwitches = styled.section`
  width: 303px;
  height: 60px;
  border-radius: 33px;
  ${layerA};
  ${flexBoxCenter};
  ${(p) =>
    p.isExpanded &&
    css`
      margin-bottom: 4px;
    `}
`;

const MobileSwitchesInner = styled.div`
  width: 300px;
  height: 58px;
  border-radius: 31px;
  ${layerA180Deg};
  ${justifyContentSpaceBetween};
  padding: 0 6px;
`;

const SectionLogo = styled.section`
  width: 44px;
  height: 44px;
  ${layerC}
  border-radius: 50%;
  ${flexBoxCenter}

  ${(p) => p.isReady && css``};
  ${(p) => p.isActivated && css``};
`;
const Button = styled.button`
  width: 42px;
  height: 42px;
  border-radius: 50%;
  ${layerA180Deg};
  ${flexBoxCenter};

  ${(p) =>
    p.noButton &&
    css`
      cursor: default;
    `}

  ${(p) =>
    p.isReady &&
    css`
      ${readyTop180Deg};
    `};
  ${(p) =>
    p.isActivated &&
    css`
      ${activeLayer180Deg};
    `};
  ${(p) =>
    p.isSelected &&
    css`
      border: 1px solid #95ff45;
    `}
`;
const ButtonHole = styled.div`
  width: 34px;
  height: 34px;
  border-radius: 50%;
  ${layerA};
  ${flexBoxCenter};
  ${(p) =>
    p.isActivated &&
    css`
      ${activeInput};
    `};
`;

const ButtonTop = styled.div`
  width: 30px;
  height: 30px;
  border-radius: 50%;
  ${layerA180Deg};
  ${flexBoxCenter};
`;

const IconImg = styled.img`
  ${(p) =>
    p.isMc ||
    css`
      height: 100%;
    `}
  ${(p) =>
    p.isAts &&
    css`
      height: 80%;
    `}
`;

const SectionController = styled.section`
  width: 238px;
  height: 48px;
  border-radius: 26px;

  ${layerA};
  ${justifyContentSpaceBetween};
  padding: 0 2px;
`;




const Wrapper = styled.div`
  width: 413px;
  ${flexBoxCenter}
  display: flex;
  flex-direction: column;
  position: relative;

  ${(p) => p.isMobile && css``}
`;
const SectionHeader = styled.section`
  width: 100%;
  position: relative;
`;

const HeaderTitleWrapper = styled.div`
  position: absolute;
  top: 0;
  padding: 0 6px;
  width: 100%;
  height: 100%;
  ${justifyContentSpaceBetween};
`;
const Title = styled.span`
  font-size: 14px;
  letter-spacing: 1.4px;

  ${(p) =>
    p.right
      ? css`
          margin-left: 8px;
        `
      : css`
          width: 53%;
          font-size: 12px;
          letter-spacing: 1.2px;
        `}
`;
const HeaderHatSvg = styled.img`
  position: relative;
`;

const SectionMain = styled.section`
  width: 413px;
  height: 665px;

  background: transparent linear-gradient(180deg, #20354e 0%, #060d19 100%);
  border: 1px solid #000000;
  border-radius: 0px 12px 12px 12px;

  ${flexBoxCenter};

  ${({ isFaults }) =>
    isFaults &&
    css`
      border: 1px solid red;
    `}
`;

const MainInnerWrapper = styled.div`
  width: 401px;
  height: 654px;
  border-radius: 8px;
  ${layerADark};
  ${flexDirectionColumn};
  padding: 1.5px 0;
`;

const MessageBoxWrapper = styled.div`
  width: 1180px;
  height: 600px;
  position: absolute;

  ${flexBoxCenter};

  top: 0;
  left: 0;
  z-index: 100;
`;
